// extracted by mini-css-extract-plugin
export var dividerLine = "_5p-3";
export var itemImage = "_5p-9";
export var lightDivider = "_5p-4";
export var modalContent = "_5p-5";
export var modalContentCompact = "_5p-6";
export var productCard = "_5p-a";
export var productImage = "_5p-b";
export var productImageCompact = "_5p-7";
export var productImagePlaceholder = "_5p-c";
export var productImagePlaceholderCompact = "_5p-8";
export var progressBarBackground = "_5p-1";
export var progressBarContainer = "_5p-0";
export var progressBarFill = "_5p-2";